import { mapGetters, mapActions } from 'vuex';
import { CALCULATOR_ERROR } from '../../components/Calculator/CalculatorDialogError';
import vehicleSearchConfigFolderJSON from './json-data/vehicle-search-config-v2.json';
import QueryVehicleSearchConfig from '../../graphql/queries/QueryVehicleSearchConfig';

export default {
  data() {
    return {
      isFetchVehicleSearchConfigLoading: false,
      useAppLoading: true
    };
  },

  computed: {
    ...mapGetters({
      orgProfile: 'theme/getOrgProfile',
      ratebookOrgId: 'theme/ratebookOrgId',
      vehicleSearchConfig: 'vehicleSearchConfig/getVehicleSearchConfig'
    }),

    countryCode() {
      return this.orgProfile?.whiteLabel?.region || 'NZ';
    },

    calculatorManufacturersEnabled() {
      return this.orgProfile?.pricingConfiguration?.calculator?.isCalculatorEnabled
        ? [...this.orgProfile?.pricingConfiguration?.calculator?.manufacturersEnabled]
        : [];
    }
  },

  methods: {
    ...mapActions({
      setApploading: 'app/setAppLoading',
      updateVehicleSearchConfig: 'vehicleSearchConfig/updateVehicleSearchConfig',
      clearVehicleSearchConfig: 'vehicleSearchConfig/clearVehicleSearchConfig'
    }),

    notifyCalculatorError() {
      this.$euiNotifications.emit({ notification: CALCULATOR_ERROR });
    },

    async fetchVehicleSearchConfig(useAppLoadingValue = true) {
      this.useAppLoading = useAppLoadingValue;

      this.clearVehicleSearchConfig();

      try {
        this.isFetchVehicleSearchConfigLoading = true;

        // const vehicleSearchConfig = this.loadVehicleSearchConfigFromJson();
        const vehicleSearchConfig = await this.loadVehicleSearchConfigFromGql();

        if (!vehicleSearchConfig) {
          this.notifyCalculatorError();
          return null;
        }

        if (!vehicleSearchConfig.generatedAt) {
          // keeping your original behaviour
          this.notifyCalculatorError();
        }

        // Store only facets in Vuex (same as your current logic)
        this.updateVehicleSearchConfig(vehicleSearchConfig.facets || {});

        return vehicleSearchConfig;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[fetchVehicleSearchConfig]', error);
        this.notifyCalculatorError();
        return null;
      } finally {
        this.isFetchVehicleSearchConfigLoading = false;
      }
    },

    /**
     * Supports common shapes:
     * 1) { generatedAt, facets, ... }
     * 2) { data: { fetchVehicleSearchConfig: { generatedAt, facets } } }
     */
    loadVehicleSearchConfigFromJson() {
      const json = vehicleSearchConfigFolderJSON;

      // if you saved the gql-like response shape to file
      const gqlLike = json?.data?.fetchVehicleSearchConfig;
      if (gqlLike) return gqlLike;

      // if you saved the raw object to file
      if (json?.facets) return json;

      return null;
    },

    async loadVehicleSearchConfigFromGql() {
      if (this.useAppLoading) this.setApploading(true);

      try {
        const response = await this.$apollo.mutate({
          mutation: QueryVehicleSearchConfig,
          fetchPolicy: 'no-cache',
          client: 'boomiClient',
          variables: {
            searchFilters: {
              countryCode: this.countryCode,
              ratebookOrgId: this.ratebookOrgId,
              ...(this.calculatorManufacturersEnabled?.length && {
                vehicleMake: this.calculatorManufacturersEnabled
              })
            }
          }
        });

        return response?.data?.fetchVehicleSearchConfig || null;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('loadVehicleSearchConfigFromGql error:', error);
        return null;
      } finally {
        if (this.useAppLoading) this.setApploading(false);
      }
    }
  }
};
